function c(r,b,n,e){return function(){return r.subscribe({query:b}).subscribe({next:t=>t?.data?n(t.data):e("no data received"),error:e})}}export{c as createObserver};
//# sourceMappingURL=createObserver.es.js.map
